import { Injectable } from '@angular/core';


import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ServiceService {

  public api = environment.api;
  public server = environment.server;

  constructor(public http: HttpClient) { 
    

  }


  public getToken() {
      return localStorage.getItem('userToken');
  }

  public getHeader(is_file){

      var data = {};

      var token = this.getToken();
      if(token){ 
        data['Authorization'] = "Bearer " + token;
      }

      if(is_file){ 
        //data['Content-Type'] = "multipart/form-data"; 
      }

      return  { headers: new HttpHeaders(data) };
  }

  public post(ruta, data) {
    return this.http.post( `${this.api}` + ruta, data, this.getHeader(false) ).pipe(map(data => {return data;}));
  }

  public postFile(ruta, data) {
    return this.http.post( `${this.api}` + ruta, data , this.getHeader(true) ).pipe(map(data => {return data;}));
  }


  public get(ruta){
    return this.http.get(`${this.api}` + ruta , this.getHeader(false) ).pipe(map(data => {return data;}));
  }



  public getResourceLocal(ruta) {
    return this.http.get(ruta).pipe(map(data => {return data;}));
  }


  ////////////////////////// SERVICOS NOT TOKEN //////////////////////////
  
  public post_p(ruta, data) {
    return this.http.post( `${this.api}` + ruta, data ).pipe(map(data => {return data;}));
  }
  public postFile_p(ruta, data) {
    return this.http.post( `${this.api}` + ruta, data ).pipe(map(data =>{return data;}));
  }
  public get_p(ruta){
    return this.http.get(`${this.api}` + ruta ).pipe(map(data =>{return data;}));
  }

}
